import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Col } from '../../../../Shared/Grid'
import { SHAPE_ROOM_DETAIL } from '../shapes'
import Icon from '../../../../Shared/Icon'
import InputTracked from '../../../../Shared/FormTracked/InputTracked'
import { trackingEvent } from '../../../../../constants'

class Detail extends PureComponent {

  componentDidMount () {
    this._validateRoomCodes()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this._validateRoomCodes()
  }

  state = {
    expediaCodeIsValid: true,
    bookingCodeIsValid: true,
  }

  getCodesMap () {
    let codes = {}
    this.props.detail.codes.forEach((code) => {
      if (!codes.hasOwnProperty(code.id)) {
        codes[code.id] = code
      }
    })
    return codes
  }

  onLabelChange (label) {
    let detail = Object.assign({}, this.props.detail)
    detail.label = label
    this.props.onChange(detail, this.state.expediaCodeIsValid && this.state.bookingCodeIsValid)
  }

  onCodeChange (id, code) {
    let detail = Object.assign({}, this.props.detail)
    const trimmedCode = code.trim()
    let codeFoundKey = null
    for (let i = 0; i < detail.codes.length; i++) {
      if (detail.codes[i].id === id) {
        codeFoundKey = i
        break
      }
    }

    if (codeFoundKey !== null) {
      if (trimmedCode === '') {
        detail.codes.splice(codeFoundKey, 1)
      } else {
        let newCodeObject = Object.assign({}, detail.codes[codeFoundKey])
        newCodeObject.code = code
        detail.codes[codeFoundKey] = newCodeObject
      }
    } else {
      if (trimmedCode !== '') {
        detail.codes.push({ id: id, code: code })
      }
    }
    this.props.onChange(detail, this.state.expediaCodeIsValid && this.state.bookingCodeIsValid)
  }

  render () {
    const { t } = this.props
    const codesMap = this.getCodesMap()
    let expediaCode = codesMap.hasOwnProperty('expedia') ? codesMap['expedia'].code : ''
    let bookingCode = codesMap.hasOwnProperty('booking') ? codesMap['booking'].code : ''
    const eventName = trackingEvent.editRoomInfoField
    let label = this.props.detail.label
    return (
      <React.Fragment>
        <Col xs={12} sm={6} lg={3}>
          <InputTracked
            eventName={eventName}
            eventOpts={{ field: 'Occupancy Expedia Room Code' }}
            onChange={(e) => {this.onCodeChange('expedia', e.target.value)}}
            label={t('editRooms.roomForm.fields.expediaRoomId.label')}
            valid={this.state.expediaCodeIsValid}
            message={t('ROOM_DETAILS_EXPEDIA_CODE_ERR_MSG')}
            labelAppend={<Icon type={'how'} tooltip={t('editRooms.roomForm.fields.expediaRoomId.tooltip')} size={'extra-small'}/>}
            value={expediaCode}/>
        </Col>
        <Col xs={12} sm={6} lg={3}>
          <InputTracked
            eventName={eventName}
            eventOpts={{ field: 'Occupancy Booking.com' }}
            onChange={(e) => {this.onCodeChange('booking', e.target.value)}}
            label={t('editRooms.roomForm.fields.bookingRoomId.label')}
            valid={this.state.bookingCodeIsValid}
            message={t('ROOM_DETAILS_BOOKING_CODE_ERR_MSG')}
            labelAppend={<Icon type={'how'} tooltip={t('editRooms.roomForm.fields.bookingRoomId.tooltip')} size={'extra-small'}/>}
            value={bookingCode}/>
        </Col>
        <Col xs={12} sm={6} lg={3}>
          <InputTracked
            eventName={eventName}
            eventOpts={{ field: 'Occupancy Label' }}
            onChange={(e) => {this.onLabelChange(e.target.value)}}
            label={t('LABEL')} value={label}
            labelAppend={<Icon type={'how'} tooltip={t('TOOLTIP_DETAIL_LABEL')} size={'extra-small'}/>}
          />
        </Col>
      </React.Fragment>
    )
  }

  _validateRoomCodes () {
    const codesMap = this.getCodesMap()
    let expediaCode = codesMap.hasOwnProperty('expedia') ? codesMap['expedia'].code : ''
    let bookingCode = codesMap.hasOwnProperty('booking') ? codesMap['booking'].code : ''
    let expediaCodeIsValid = expediaCode.length < 1 || /^[^|;:]*$/.test(expediaCode)
    let bookingCodeIsValid = bookingCode.length < 1 || /^\d*$/.test(bookingCode)
    if (
      expediaCodeIsValid !== this.state.expediaCodeIsValid
      || bookingCodeIsValid !== this.state.bookingCodeIsValid
    ) {
      this.setState({
        expediaCodeIsValid,
        bookingCodeIsValid,
      }, () => {
        this.props.onChange(
          { ...this.props.detail },
          this.state.expediaCodeIsValid && this.state.bookingCodeIsValid
        )
      })
    }
  }
}

Detail.propTypes = {
  detail: SHAPE_ROOM_DETAIL.isRequired,
  onChange: PropTypes.func.isRequired
}

export default withTranslation()(Detail)
